module.exports = __webpack_public_path__ + "img/9A5A55_31110D_582A24_703C34-256px.e751c3e6.png";